import { createLocale } from '#/localization/lib/locale-factory';

import homeLocale from './home';
import settingsLocale from './settings';

export default createLocale('pages', {
  ...homeLocale,
  ...settingsLocale,
});
